import { authApi } from "../api-calls/user-requests";
import { EXPENSE_APPROVALS_COUNT } from "../api-calls/api-urls";
import { setExpensePendingCount } from "../Redux/actions/user-actions";

// Presentation shared by the Expense Approvals page and the expense report.
// Type colours match the mobile app and the backend PDF (data/expenseReport.js).
export const EXPENSE_TYPE_META = {
  travelling: { label: "Travelling", color: "#6366F1" },
  food: { label: "Food", color: "#10B981" },
  accommodation: { label: "Accommodation", color: "#F59E0B" },
  material: { label: "Material", color: "#3B82F6" },
  misc: { label: "Others", color: "#94A3B8" },
};

export const EXPENSE_TYPES = Object.keys(EXPENSE_TYPE_META);

// Stored "submitted" is presented as "Pending" everywhere.
export const EXPENSE_STATUS_LABELS = {
  submitted: "Pending",
  approved: "Approved",
  rejected: "Rejected",
};

export const EXPENSE_STATUSES = Object.keys(EXPENSE_STATUS_LABELS);

export const REJECTION_REASON_MAX = 250;

/** "1,25,000.00" — Indian grouping, matching the PDF/Excel output. */
export const formatAmount = (value) =>
  new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value) || 0);

/** Displayable URL for a stored bill, mirroring the backend's resolveImageUrl. */
export const resolveBillUrl = (bill) => {
  if (!bill) return "";
  if (bill.location && /^https?:\/\//i.test(bill.location)) return bill.location;
  if (bill.destination && /^https?:\/\//i.test(bill.destination)) {
    if (!bill.filename) return bill.destination;
    return bill.destination.endsWith("/")
      ? `${bill.destination}${bill.filename}`
      : `${bill.destination}/${bill.filename}`;
  }
  return "";
};

export const isPdfBill = (bill) =>
  bill?.mimetype === "application/pdf" || /\.pdf($|\?)/i.test(resolveBillUrl(bill));

/**
 * Refreshes the sidebar's pending-approval badge. The web app gets no push, so
 * this runs on load, when the tab regains focus, with the notification bell
 * and after every approve/reject. Failures (e.g. a non-leader account, which
 * the endpoint refuses) just leave the badge empty.
 */
export const fetchPendingExpenseCount = async (dispatch) => {
  try {
    const { data } = await authApi.get(EXPENSE_APPROVALS_COUNT);
    dispatch(setExpensePendingCount(data?.data?.count || 0));
  } catch (error) {
    dispatch(setExpensePendingCount(0));
  }
};
